
define(
	'NVT.MyEventAgenda.MyEventAgendaModule'
,   [
		'NVT.MyEventAgenda.MyEventAgendaModule.View',
		'Facets.ItemCell.View',
		'ProductDetails.Full.View'
		]
,   function (
		MyEventAgendaModuleView,
		FacetsItemCellView,
		ProductDetailsFullView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');

			if(layout)
			{
				layout.addChildView('Product.Information', function() {
					return new MyEventAgendaModuleView({ container: container });
				});

			}
			//below code is to get the required fields from item master and show plp page

			_.extend(FacetsItemCellView.prototype, {

					getContext: _.wrap(FacetsItemCellView.prototype.getContext, function getContext(fn) {
						var retVal = fn.apply(this, _.toArray(arguments).slice(1));
						//console.log(this.model);
							var ems_issupevent=this.model.get('custitem_nus_ems_issupevent');

						var eventmode=this.model.get('custitem_nus_ems_event_mode');
						var eventstartDate=this.model.get('custitem_nus_event_sdate');
						//	console.log("The value of eventstartDate is " + eventstartDate);
						var eventEndDate=this.model.get('custitem_nus_eventedate');

						var eventstartDate_short=this.model.get('custitem_nus_event_sdate');
						if(eventEndDate){
										var parts = eventEndDate.split('/');
										let date = new Date(parts[2], parts[1] - 1, parts[0])
										let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
										let month = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);
										let day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);
//let days = day + (day == 31 || day == 21 || day == 1 ? "st" : day == 22 || day == 2 ? "nd" : day == 23 || day == 3 ? "rd" : "th");
										let newDateFormat_edate = day +' ' +month+ ' ' +year;
										eventEndDate =  newDateFormat_edate;
									}
										//console.log("The value of eventEndDate is " + eventEndDate);
						if(eventstartDate){
										var parts = eventstartDate.split('/');
										let date = new Date(parts[2], parts[1] - 1, parts[0])
										let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
										let month = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);
										let day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);
//let days = day + (day == 31 || day == 21 || day == 1 ? "st" : day == 22 || day == 2 ? "nd" : day == 23 || day == 3 ? "rd" : "th");

										let newDateFormat = day +' ' +month+ ' ' +year;
										eventstartDate =  newDateFormat;
										//console.log(eventstartDate);
									}
									if(eventstartDate_short){
										var parts = eventstartDate_short.split('/');
										var date = new Date(parts[2], parts[1] - 1, parts[0])
										var year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
										var month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
										var day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
										var newDateFormat_short = day +'\n'+month;
										eventstartDate_short = newDateFormat_short;
									}

						var eventstartTime=this.model.get('custitem_event_stime');
						var eventendTime=this.model.get('custitem_nus_eventetime');
						var price3=this.model.get('pricelevel5');
						var price4=this.model.get('pricelevel5_formatted');
						var price5=this.model.get('pricelevel2_formatted');
var equalDates;
if(eventEndDate === eventstartDate){
	equalDates = "start and end dates are equal";
}
					//	var price5 = Number(price5_1).toFixed(2);

					//var date = new Date(eventstartDate);

//var formattedDate = date.getDay();

						_.extend(retVal, {
							ems_issupevent:ems_issupevent,
							eventmode:eventmode,
							eventstartDate:eventstartDate,
							eventEndDate:eventEndDate,
							eventstartDate_short:eventstartDate_short,
							eventstartTime:eventstartTime,
							eventendTime:eventendTime,
							price3:price3,
							price4:price4,
							price5:price5,
							equalDates:equalDates
			});
						return retVal;
					})
				});
//end


		}

	};
});
